import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, Divider } from '@mui/material';
import GenericStyledTable from './GenericStyledTable';

const GenericCardWrapper = ({
    children,
    showDivider = true,
    withStyledTable = true,
    customDivider = null,
    tableProps = {},
    cardSx = {},
    contentSx = {},
    elevation = 1,
    footerContent = null,
}) => {
    return (
        <Card
            elevation={elevation}
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: 2,
                padding: 2,
                backgroundColor: '#fff',
                ...cardSx,
            }}
        >
            <Box sx={{ ...contentSx }}>
                {children}
                {showDivider && (customDivider || <Divider sx={{ my: 2 }} />)}
                {withStyledTable && <GenericStyledTable {...tableProps} />}
                {footerContent}
            </Box>
        </Card>
    );
};

GenericCardWrapper.propTypes = {
    children: PropTypes.node,
    showDivider: PropTypes.bool,
    withStyledTable: PropTypes.bool,
    customDivider: PropTypes.node,
    tableProps: PropTypes.object,
    cardSx: PropTypes.object,
    contentSx: PropTypes.object,
    elevation: PropTypes.number,
    footerContent: PropTypes.node,
};

GenericCardWrapper.defaultProps = {
    children: null,
    showDivider: true,
    withStyledTable: true,
    customDivider: null,
    tableProps: {},
    cardSx: {},
    contentSx: {},
    elevation: 1,
    footerContent: null,
};

export default GenericCardWrapper;
